export class ModalInput {

  constructor(public type: string,
              public formControlName?: string,
              public validator?: Array<any>,
              public data?: any) {
  }
}
